
import { createToaster, HoldSource, IToast, IToaster } from '@/pure/toast';
import { IFlash } from '@/types';
import Vue from 'vue';

const windowTimers = {
  clear: (handle: number) => window.clearTimeout(handle),
  set: (fn: () => void, ms: number) => window.setTimeout(fn, ms),
};

const ICONS = { done: 'check', note: 'info', problem: 'exclamation-triangle' };

export default Vue.extend({
  name: 'IgsToaster',
  data(): { shown: IToast[]; toaster: IToaster | null } {
    return { shown: [], toaster: null };
  },
  created() {
    this.toaster = createToaster(windowTimers, (shown) => {
      this.shown = shown;
    });
  },
  methods: {
    add(flash: IFlash) {
      this.toaster?.add(flash);
    },
    close(id: number) {
      this.toaster?.close(id);
    },
    hold(id: number, source: HoldSource) {
      this.toaster?.hold(id, source);
    },
    icon(toast: IToast) {
      return ICONS[toast.kind];
    },
    // Focus moving between parts of the same toast keeps the hold.
    release(id: number, source: HoldSource, event?: FocusEvent) {
      const box = event?.currentTarget;
      const next = event?.relatedTarget;
      if (box instanceof Node && next instanceof Node && box.contains(next)) return;
      this.toaster?.release(id, source);
    },
  },
});
